import { IDocumentMetadata } from "@multiweb/types/contracts";
import { DataConverter } from "../../Global/Base/Converters/DataConverter";
import { ISignatureDataStream } from "../Crypto/CryptoInterfaces";
import { ISignatureReferenceUriGenerator } from "./ISignatureReferenceUriGenerator";
import { RemotingObjectReferenceUriGenerator } from "./RemotingObjectReferenceUriGenerator";

/**
 * Stream s daty pro vytvoření podpisu aplikačního objektu
 */
export class ObjectSignatureStream implements ISignatureDataStream {
    private readonly _objectData: string;
    private readonly _objectName: string;
    private readonly _referenceUriGenerator: ISignatureReferenceUriGenerator;

    /**
     * Vytvoří stream s daty pro vytvoření podpisu aplikačního objektu
     * @param objectName lidský název záznamu zobrazený uživateli
     * @param serializationFormat identifikátor formátu, který byl použit pro serializaci (složení) dat
     * @param templateIdentifier identifikátor šablony použité pro vytvoření podpisu
     * @param objectData data k podpisu
     */
    constructor(objectName: string, serializationFormat: string, templateIdentifier: string, objectData: string) {
        this._objectData = objectData;
        this._objectName = objectName;
        this._referenceUriGenerator = new RemotingObjectReferenceUriGenerator(serializationFormat, templateIdentifier);
    }

    public async read(chunkSize: number, onChunkDownloaded: (chunk: ArrayBuffer, isLastChunk: boolean) => Promise<void>): Promise<void> {
        const objDataByteArray = DataConverter.base64ToArray(DataConverter.btoaUtf8(this._objectData));
        const arrayLength = objDataByteArray.length;

        for (let chunkStart = 0; chunkStart < arrayLength; chunkStart += chunkSize) {
            const chunkEnd = chunkStart + chunkSize;
            const isLastChunk = chunkEnd >= arrayLength;
            const chunk = objDataByteArray.slice(chunkStart, chunkEnd);
            await onChunkDownloaded(chunk.buffer, isLastChunk);
        }
    }

    public getName(): Promise<string> {
        return Promise.resolve(this._objectName);
    }

    public getMetadata(): Promise<IDocumentMetadata | null> {
        return Promise.resolve(null);
    }

    public getReferenceUri(): Promise<string> {
        return this._referenceUriGenerator.getReferenceUri();
    }
}
